import * as React from "react";
import Button from "@mui/material/Button";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Cancel";
import Stack from "@mui/material/Stack";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { CircularProgress } from "@mui/material";

const SaveCancel = (props) => {
  const { cancelBtn, resetForm, isLoading } = props;
  const { t } = useTranslation();
  return (
    <Stack direction="row-reverse" spacing={2}>
      <Button
        type="submit"
        variant="contained"
        startIcon={<SaveIcon />}
        endIcon={isLoading ? <CircularProgress size={24} /> : null}
        disabled={isLoading}
      >
        {t("Save")}
      </Button>
      <Button variant="outlined" startIcon={<CancelIcon />} onClick={cancelBtn}>
        {t("Cancel")}
      </Button>
      <Button
        variant="outlined"
        startIcon={<RestartAltIcon />}
        onClick={() => {
          resetForm();
        }}
      >
        {t("Reset")}
      </Button>
    </Stack>
  );
};
SaveCancel.propTypes = {
  cancelBtn: PropTypes.func,
  resetForm: PropTypes.func,
};

export default SaveCancel;
